export const teamData = {
    teamA: {
        colour: 'Pomarańczowi',
        label: 'pomaranczowi',
        class: 'orange',
        code: 'sdfg78df',
    },
    teamB: {
        colour: 'Zieloni',
        label: 'zieloni',
        class: 'green',
        code: 'vbts32fv',
    },
    teamC: {
        colour: 'Fioletowi',
        label: 'fioletowi',
        class: 'violet',
        code: 'sxcv53vc',
    },
    teamD: {
        colour: 'Niebiescy',
        label: 'niebiescy',
        class: 'blue',
        code: 'hdvbt36fg',
    },
};
